import { inject, Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalConfigInterface, ModalsService } from '@shared/ui/modals';
import { Observable } from 'rxjs';
import { FormComponent } from './form.component';
import { FormButtonTypeEnum, FormDataInterface } from './form.interface';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  private readonly modalsService = inject(ModalsService);

  openConfirmationForm(
    title: string,
    action: () => Observable<unknown>,
  ): MatDialogRef<FormComponent> {
    return this.openForm({
      data: {
        title: title,
        actions: [
          {
            type: FormButtonTypeEnum.SECONDARY,
          },
          {
            action,
            focus: true,
            type: FormButtonTypeEnum.PRIMARY,
          },
        ],
      },
    });
  }

  openForm(
    config: ModalConfigInterface<FormDataInterface>,
  ): MatDialogRef<FormComponent> {
    return this.modalsService.open<FormComponent, FormDataInterface>(
      FormComponent,
      config,
    );
  }
}
